import React from 'react';
import Card from '../Card/Card';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import { LazyLoadedImage } from '@hedinbil/hedin-ui/dist/utils/components/LazyLoadedImage';
import { fallbackImagePath } from '../../Project/bavaria-no/utils/fallbackImagePath';

const SiteCard = (props) => {
  const { image, address, phone, link, item, isEditing, onClick } = props;
  const fallbackpath = fallbackImagePath(address?.city, false);

  return (
    <Card className="card__white" hover link={link} onClick={onClick}>
      <div className="car-card__image-container">
        <LazyLoadedImage
          src={fallbackpath}
          className="d-inherit card__image"
          isEditing={isEditing}
          alt={item?.name}
        />
      </div>
      <div className="site-list__item-content d-flex flex-column">
        <p className="site-list__item-title h-mb-3 text-uppercase color-black">{item?.name}</p>
        <div className="site-list__item-info h-mb-2 d-flex">
          <HedinIcon iconName="CarContactPin" />
          <p className="site-list__item-text mb-0">
            {`${address?.street ? address?.street : ''} ${
              address?.streetnumber ? address?.streetnumber + ', ' : ''
            } ${address?.zip ? address?.zip : ''} ${address?.city ? address?.city : ''}`}
          </p>
        </div>
        <div className="site-list__item-info h-mb-2">
          {phone ? (
            <>
              <HedinIcon iconName="Phone" />
              <p className="site-list__item-text mb-0">{phone}</p>
            </>
          ) : null}
        </div>
      </div>
    </Card>
  );
};

export default SiteCard;
